<template>
    <button type="button" class="btn btn-sm shadow-sm btn-outline-secondary" id="keep-toggle" @click="toggle">
        <input type="checkbox" v-model="state" id="keep-toggle-checkbox">
        Behalten
    </button>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        },
        calculationId: {
            type: Number,
            required: true
        },
        originalState: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            state: this.originalState
        };
    },
    methods: {
        toggle() {
            this.state = !this.state;
            axios.post('/calculations/' + this.calculationId + '/set-keep', {
                _token: this.token,
                state: this.state
            });
        }
    },
}
</script>

<style scoped>

</style>
